import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { normalizeClientAppOpenHouse } from 'data/listing/open-house/normalize-open-house';

dayjs.extend(utc);
dayjs.extend(timezone);

export type OpenHouseSerializableProperties = ReturnType<typeof OpenHouse.prototype.toJSON>;

export class OpenHouse {
  to: string | null;
  from: string | null;
  date: string | null;
  // IANA timezone of the property the open house is at, e.g. "America/Toronto".
  // Populated by the go-search adapter from the proto's `timezone` field; null
  // on the legacy client-app fallback path. The formatter switches behavior on
  // this presence/absence.
  timezone: string | null;

  constructor(openHouse: Record<string, unknown>) {
    const normalized = normalizeClientAppOpenHouse(openHouse);
    this.to = normalized.to;
    this.from = normalized.from;
    this.date = normalized.date;
    this.timezone = normalized.timezone;
  }

  toJSON() {
    return {
      to: this.to,
      from: this.from,
      date: this.date,
      timezone: this.timezone,
    };
  }

  get isActive() {
    if (this.date) {
      const date = new Date(this.date);
      const hoursMatch = this.to?.match(/^(\d+):/);
      if (hoursMatch) {
        date.setHours(parseInt(hoursMatch[1], 10) + (this.to?.match(/pm/i) ? 12 : 0));
      }
      const minutesMatch = this.to?.match(/:(\d+)/);
      if (minutesMatch) {
        date.setMinutes(parseInt(minutesMatch[1], 10));
      }
      return date > new Date();
    }
    return false;
  }
}
